import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import React, { useContext } from 'react';
import { FaShoppingBasket } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import { Link } from 'gatsby';
import { StoreContext } from '../../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Indicator = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1508egs0"
} : {
  target: "e1508egs0",
  label: "Indicator"
})(process.env.NODE_ENV === "production" ? {
  name: "6erqba",
  styles: "width:10px;height:10px;border-radius:50%;background-color:#e74c3c;position:absolute;bottom:-3px;right:-2px"
} : {
  name: "6erqba",
  styles: "width:10px;height:10px;border-radius:50%;background-color:#e74c3c;position:absolute;bottom:-3px;right:-2px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3MvZWNvbW1lcmNlLWFkZG9uL3NyYy9jb21wb25lbnRzL0NhcnRJY29uL0NhcnRJY29uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVE0QiIsImZpbGUiOiIvYXBwL25vZGVfbW9kdWxlcy9AaW50ZXJuZXNzL2Vjb21tZXJjZS1hZGRvbi9zcmMvY29tcG9uZW50cy9DYXJ0SWNvbi9DYXJ0SWNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgRmFTaG9wcGluZ0Jhc2tldCB9ICBmcm9tICdyZWFjdC1pY29ucy9mYSc7XG5pbXBvcnQgUmVhY3RUb29sdGlwICAgICAgICAgIGZyb20gJ3JlYWN0LXRvb2x0aXAnO1xuaW1wb3J0IHsgTGluayB9ICAgICAgICAgICAgICBmcm9tICdnYXRzYnknO1xuaW1wb3J0IHN0eWxlZCAgICAgICAgICAgICAgICBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBTdG9yZUNvbnRleHQgfSBmcm9tICcuLi8uLi9jb250ZXh0L1N0b3JlJztcblxuY29uc3QgSW5kaWNhdG9yID0gc3R5bGVkLmRpdmBcbiAgd2lkdGg6IDEwcHg7XG4gIGhlaWdodDogMTBweDtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTc0YzNjO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGJvdHRvbTogLTNweDtcbiAgcmlnaHQ6IC0ycHg7XG5gO1xuXG5jb25zdCBDYXJ0SWNvbiA9ICgpID0+IHtcbiAgY29uc3QgeyBjYXJ0LCBzdG9yZVJvb3RQYXRoIH0gPSB1c2VDb250ZXh0KFN0b3JlQ29udGV4dCk7XG4gIGlmICghc3RvcmVSb290UGF0aCkge1xuICAgIHJldHVybiBudWxsO1xuICB9XG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxMaW5rIHN0eWxlPXt7IHBvc2l0aW9uOiAncmVsYXRpdmUnIH19IHRvPXtgJHtzdG9yZVJvb3RQYXRofS93YXJlbmtvcmJgfT5cbiAgICAgICAgPEZhU2hvcHBpbmdCYXNrZXQgZGF0YS10aXA9e2BXYXJlbmtvcmIgKCR7Y2FydC50b3RhbENvdW50fSlgfS8+XG4gICAgICAgIHtjYXJ0LnRvdGFsQ291bnQgPiAwICYmIDxJbmRpY2F0b3IvPn1cbiAgICAgIDwvTGluaz5cbiAgICAgIDxSZWFjdFRvb2x0aXAvPlxuICAgIDwvPlxuICApO1xufVxuXG5leHBvcnQgZGVmYXVsdCBDYXJ0SWNvbjsiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const CartIcon = () => {
  const {
    cart,
    storeRootPath
  } = useContext(StoreContext);
  if (!storeRootPath) {
    return null;
  }
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Link, {
    style: {
      position: 'relative'
    },
    to: `${storeRootPath}/warenkorb`
  }, ___EmotionJSX(FaShoppingBasket, {
    "data-tip": `Warenkorb (${cart.totalCount})`
  }), cart.totalCount > 0 && ___EmotionJSX(Indicator, null)), ___EmotionJSX(ReactTooltip, null));
};
export default CartIcon;